import React from 'react'
import { Backdrop, Paper, Button, IconButton } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons'

function CarrouselModal(_props) {
  const {
    open = false,
    handleClose = () => {
      console.log('Please provide a handleClose function')
    },
    images = [
    ],
  } = _props

  const activeSlideRef = React.useRef(0)
  const carrouselRef = React.useRef(null)
  const carrouselWrapperRef = React.useRef(null)
  const markersWrapperRef = React.useRef(null)

  function handleSlideChange(event, value) {
    event.stopPropagation()
    if (activeSlideRef.current === value) return true
    activeSlideRef.current = value
    carrouselRef.current.style.transform = `translateX(-${value * 100}%)`
    setActiveMarker()
  }

  function handleSlideNext(event) {
    event.stopPropagation()
    if (activeSlideRef.current === images.length - 1) return true
    activeSlideRef.current += 1
    carrouselRef.current.style.transform = `translateX(-${
      activeSlideRef.current * 100
    }%)`
    setActiveMarker()
  }

  function handleSlidePrevious(event) {
    event.stopPropagation()
    if (activeSlideRef.current === 0) return true
    activeSlideRef.current -= 1
    carrouselRef.current.style.transform = `translateX(-${
      activeSlideRef.current * 100
    }%)`
    setActiveMarker()
  }

  function setActiveMarker() {
    Array.from(markersWrapperRef.current.children).forEach((marker, index) => {
      if (index === activeSlideRef.current) {
        marker.classList.add('active')
      } else {
        marker.classList.remove('active')
      }
    })
  }



  return (
    <Backdrop ref={carrouselWrapperRef} open={open} onClick={handleClose}>
      <Paper
        className="w-1/2 fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 "
        elevation={8}
      >
        <div className="block w-full pb-[56%] relative rounded-inherit overflow-hidden">
          <div
            ref={carrouselRef}
            className="transition-transform duration-500 absolute w-full h-full flex flex-row flex-nowrap justify-start rounded-inherit"
          >
            {images.map((image, index) => (
              <div key={index} className="min-w-full h-full">
                <img
                  src={image}
                  alt="carrousel"
                  className="w-full h-full object-contain relative"
                />
              </div>
            ))}
          </div>
        </div>
        <div
          id="carrousel-markers"
          ref={markersWrapperRef}
          className="absolute top-[calc(100%+1rem)] left-1/2 -translate-x-1/2 inline-flex flex-row gap-4"
        >
          {images.length > 1 &&
            images.map((image, index) => (
              <Button
                key={image + index}
                variant="dot"
                className={`marker-slide-${index} ${
                  index === activeSlideRef.current ? 'active' : ''
                }`}
                onClick={(e) => {
                  handleSlideChange(e, index)
                }}
              />
            ))}
        </div>
        <div
          id="carrousel-previous"
          className="absolute top-1/2 -left-8 -translate-x-1/2 -translate-y-1/2"
        >
          <IconButton
            size="large"
            onClick={handleSlidePrevious}
            color="primary"
          >
            <FontAwesomeIcon icon={faChevronLeft} size="1x" />
          </IconButton>
        </div>
        <div
          id="carrousel-next"
          className="absolute top-1/2 -right-8 translate-x-1/2 -translate-y-1/2"
        >
          <IconButton size="large" onClick={handleSlideNext} color="primary">
            <FontAwesomeIcon icon={faChevronRight} size="1x" />
          </IconButton>
        </div>
      </Paper>
    </Backdrop>
  )
}

export default CarrouselModal
